// Loading.js
import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthService from '../../services/authService';

const Login = () => {
    const [userId, setUserId] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        // 이미 로그인된 사용자는 메인 페이지로 리다이렉트
        if (AuthService.getToken()) {
            navigate('/');
        }
    }, [navigate]);

    const handleSubmit = async e => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            const response = await AuthService.login(userId, password);
            if (response) {
                navigate('/');
            } else {
                setError('로그인에 실패했습니다.');
            }
        } catch (err) {
            setError(err.message || '로그인 중 오류가 발생했습니다.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="account-pages my-5">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-md-8 col-lg-6 col-xl-4">
                        <div className="text-center">
                            <p
                                className="text-center mt-2 mb-4"
                                style={{
                                    fontSize: '2.5rem',
                                    fontWeight: 900,
                                    color: '#2e5bff',
                                    // letterSpacing: '0.2em',
                                    margin: '0 auto',
                                    maxWidth: '220px',
                                }}
                            >
                                ADHELP
                            </p>
                        </div>
                        <div className="card">
                            <div className="card-body p-4">
                                <div className="text-center mb-4">
                                    <h4 className="text-uppercase mt-0">Sign In</h4>
                                </div>

                                {error && (
                                    <div className="alert alert-danger" role="alert">
                                        {error}
                                    </div>
                                )}

                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label htmlFor="userId" className="form-label">
                                            아이디
                                        </label>
                                        <input
                                            className="form-control"
                                            type="text"
                                            id="userId"
                                            required
                                            placeholder="아이디 입력"
                                            value={userId}
                                            onChange={e => setUserId(e.target.value)}
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="password" className="form-label">
                                            비밀번호
                                        </label>
                                        <input
                                            className="form-control"
                                            type="password"
                                            required
                                            id="password"
                                            placeholder="비밀번호 입력"
                                            value={password}
                                            onChange={e => setPassword(e.target.value)}
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <div className="form-check">
                                            <input
                                                type="checkbox"
                                                className="form-check-input"
                                                id="checkbox-signin"
                                                checked
                                            />
                                            <label
                                                className="form-check-label"
                                                for="checkbox-signin"
                                            >
                                                Remember me
                                            </label>
                                        </div>
                                    </div>

                                    <div className="mb-3 d-grid text-center">
                                        <button
                                            className="btn btn-primary"
                                            type="submit"
                                            disabled={loading}
                                        >
                                            {loading ? '로그인 중...' : '로그인'}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>

                        <div className="row mt-3">
                            <div className="col-12 text-center">
                                {/* <p>
                                    {' '}
                                    <a href="pages-recoverpw.html" className="text-muted ms-1">
                                        <i className="fa fa-lock me-1"></i>Forgot your password?
                                    </a>
                                </p> */}
                                {/* <p className="text-muted">
                                    Don't have an account?{' '}
                                    <a href="pages-register.html" className="text-dark ms-1">
                                        <b>Sign Up</b>
                                    </a>
                                </p> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export { Login };
